<template lang="pug">
  .modal.is-active(v-if="isModalActive" :class="{'modal-sidebar-desktop-open': showSidebarDesktop }")
    .modal-background(@click="isModalActive = false")
    .box.position-relative.has-text-left.margin-right-10.margin-left-10
      div
        span.name Tienes los siguientes documentos por firmar y cargar:
      div
        span.text-small(v-for="(o,index) in lista")
          | {{ o.descripcion }}
          br
      br
      button.button.is-primary(@click="goToMisDocumentos()") Ir a mis documentos por firmar
</template>

<script>
import { apiGet } from '../util/general'
export default {
  name: 'mis_documentos_sin_cargar',
  data () {
    return {
      lista:[],
      isModalActive: false
    }
  },
  computed: {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  created () {
    // Verifica si ya estás en la ruta '/mis-documentos-firmar'
    if (this.$route.path !== '/mis-documentos-firmar') {
      this.fetch()
    } else {
      this.isModalActive = false
    }
  },
  methods: {
    fetch () {
      var vm = this
      apiGet(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
        if (data.lista.length > 0) {
          vm.isModalActive = true
          vm.lista = data.lista
        }
      })
    },
    goToMisDocumentos () {
      this.$router.push('/mis-documentos-firmar')
      this.isModalActive = false
    }
  }
}
</script>
<style lang="stylus" scoped>

  .seen-vacaciones
    background-color: #FF9800;
    padding: 0px 42px;
    margin-top: 3px;
    border-radius: 4px;
    color: #333;
  .seen-solicitud-vacaciones
    background-color: #f7d4a1;
    padding: 0px 4px;
    margin-top: 3px;
    border-radius: 4px;
    color: #333;
  .seen-solicitud-permisos
    background-color: #aac3eb;
    padding: 0px 10px;
    margin-top: 3px;
    border-radius: 4px;
    color: #333;
  .seen-permisos
    background-color: #5390f3;
    padding: 0px 48px;
    margin-top: 3px;
    border-radius: 4px;
    color: #333;
  .leyenda
    justify-content: space-evenly;
    flex-wrap: wrap;
    padding: 10px;
  .margin-left-10
    margin-left 10px
  .is-overlay
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
  .text-small
    font-size 12px
    color #9a9a9a
  .name
    font-size: 16px;

  >>> .vacaciones
    background-color: #FF9800 !important
  >>> .solicitud-vacaciones
    background-color: #f7d4a1 !important
  >>> .permisos
    background-color: #5390f3 !important
  >>> .solicitud-permisos
    background-color: #aac3eb !important
  .cv-wrapper
    height: calc(100dvh - 125px);

  @media (max-width: 607px)
    .filtros-check
      flex-direction: column;
      max-width: fit-content;
      .control
        margin-left: 0px !important;
</style>




// WEBPACK FOOTER //
// Component_Mis_Documentos_Sin_Cargar.vue?2799f4a6